/* eslint-disable no-magic-numbers */

export enum EHttpErrorStatus {
  notFound = 404,
  serverIssue = 500,
  noAccess = 403,
  invalidId = 422,
}
